export default "__VITE_ASSET__MRVSFmUd__"